import React, { useEffect } from 'react';
import { heapTrackEvent } from '@marvelapp/core';
import badLuck from '../assets/images/bad-luck.gif';
import { MarvelLogo } from './icons';
import styles from './NotFound.module.css';
export default function NotFound() {
    useEffect(function () {
        heapTrackEvent('404 Appeared (Prototype)', {
            pathname: window.location.pathname,
        });
    }, []);
    return (React.createElement("section", { className: styles.table },
        React.createElement("div", { className: styles.tablecell },
            React.createElement("div", { className: styles.pagewrap },
                React.createElement("a", { className: styles.logo, href: "/" },
                    React.createElement(MarvelLogo, null)),
                React.createElement("img", { alt: "Oh no, bad luck!", className: styles.image, src: badLuck }),
                React.createElement("h1", { className: styles.heading }, "Oh no, bad luck!"),
                React.createElement("h2", { className: styles.subheading }, "The project you\u2019re looking for could have been deleted or never have existed.")))));
}
